import { render, staticRenderFns } from "./DialogQuestions.vue?vue&type=template&id=07ed8a40&"
import script from "./DialogQuestions.vue?vue&type=script&lang=js&"
export * from "./DialogQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports